export const products = [
  // --- BURGERS ---
  { id: 1, name: "Zinger Burger", price: 550, category: "Burgers", image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400" },
  { id: 10, name: "Classic Beef", price: 950, category: "Burgers", image: "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=400" },

  // --- DESI ---
  { id: 2, name: "Chicken Biryani", price: 450, category: "Desi", image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400" },
  { id: 12, name: "Chicken Karahi", price: 1400, category: "Desi", image: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400" },

  // --- PIZZA ---
  { id: 3, name: "Pepperoni Pizza", price: 1200, category: "Pizza", image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400" },
  { id: 14, name: "Fajita Pizza", price: 1150, category: "Pizza", image: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=400" },

  // --- BEVERAGES ---
  { id: 6, name: "Mint Margarita", price: 350, category: "Beverages", image: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=400" },
  { id: 7, name: "Blue Lagoon", price: 420, category: "Beverages", image: "https://images.unsplash.com/photo-1536935338788-846bb9981813?w=400" }
];